
import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import BatchTransfer from "../Components/Dashboard/Manage-My-Program/BatchTransfer";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthBatchTransfer = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <BatchTransfer /> : <SessionTimeoutRedirect />
}
export default AuthBatchTransfer;


